import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["screen"]
  static values = {
    delay: { type: Number, default: 3000 },
    fadeDuration: { type: Number, default: 500 },
  }

  connect() {
    this.hideTimeout = setTimeout(() => this.hide(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.hideTimeout)
    clearTimeout(this.removeTimeout)
  }

  hide() {
    this.screenTarget.style.opacity = "0"
    this.removeTimeout = setTimeout(() => {
      this.screenTarget.style.display = "none"
    }, this.fadeDurationValue)
  }
}
